import {
  CustomerType,
  SharedTripStatus,
  Trip,
  TripCommandMeta,
  TripStatus,
} from 'src/.gen/graphql';
import { splitByCamelCase } from './stringUtils';

export const parseNameCommand = (
  command: TripCommandMeta,
  status: TripStatus,
): string => {
  const { name, typeName } = command;

  switch (true) {
    case typeName === 'CancelTrip' && status === TripStatus.Draft:
      return 'Discard Trip';
    default:
      return name;
  }
};

type TypeNameButton = 'Save' | 'Discard' | 'Update';

const defaultNames = {
  Save: 'Save Quote',
  Discard: 'Cancel',
  Update: 'Update',
};

export const parseButtonLabelEditView = (
  type: TypeNameButton,
  status: TripStatus,
): string => {
  switch (true) {
    case type === 'Discard' && !status:
      return 'Cancel';
    case type === 'Discard' &&
      (status === TripStatus.Draft || status === TripStatus.AwaitingAssignment):
      return 'Cancel';
    case type === 'Discard' && status === TripStatus.Quoted:
      return 'Discard Quote';
    case type === 'Update' &&
      (!status || status === TripStatus.Draft || status === TripStatus.Quoted):
      return 'Submit Trip Request';
    default:
      return defaultNames[type];
  }
};

export const displayButtonEditView = (
  type: TypeNameButton,
  status: TripStatus,
): boolean => {
  switch (true) {
    case type === 'Save' && status && status !== TripStatus.Draft:
    case type === 'Save' && !status:
      return false;
    default:
      return true;
  }
};

export const filterTripCommands = (
  status: TripStatus,
  command: TripCommandMeta,
  iOwnThisTrip: boolean,
  isShared?: boolean,
): boolean => {
  if (command.hidden) {
    return false;
  }

  if (!iOwnThisTrip) {
    switch (true) {
      case command.typeName === 'ReassignmentRequested' && isShared:
        return false;
      case command.typeName === 'RevokeNetworkSharedTrip':
        return false;
      case command.typeName === 'RecordTransaction' ||
        command.typeName === 'SendQuote':
        return false;
      case command.typeName === 'CancelTrip':
        return false;
      case command.typeName === 'InvoiceSubmitted':
        return false;
      case command.typeName === 'InvoicePaid':
        return false;
      default:
        return true;
    }
  }

  switch (true) {
    case command.typeName === 'ReassignmentRequested' && isShared:
      return false;
    case command.typeName === 'DeclineNetworkOffer':
      return false;
    case command.typeName === 'DeclineNetworkConfirmationRequest':
      return false;
    case command.typeName === 'RecordTransaction' ||
      command.typeName === 'SendQuote':
      return false;
    case command.typeName === 'CancelTrip' && status === TripStatus.Draft:
      return false;
    case command.typeName === 'InvoiceSubmitted':
      return false;
    case command.typeName === 'InvoicePaid':
      return false;
    default:
      return true;
  }
};

export function getStatusLabel(status: TripStatus | SharedTripStatus): string {
  switch (status) {
    case TripStatus.EnRouteToPickup:
      return 'En Route';
    case TripStatus.OnLocation:
      return 'Driver Onsite';
    case TripStatus.TransportComplete:
      return 'Passenger Dropped';
    case TripStatus.TripComplete:
      return 'Completed';
    case TripStatus.Confirmed:
      return 'Driver Assigned';
    default:
      return splitByCamelCase(status);
  }
}

export function getTripStatusTimestampLabel(status: TripStatus): string {
  switch (status) {
    case TripStatus.EnRouteToPickup:
      return 'Garage Out';
    case TripStatus.TripComplete:
      return 'Garage In';
    default:
      return getStatusLabel(status);
  }
}

export function filteredTripStatuses(): string[] {
  return Object.keys(TripStatus).filter(
    (k) => k !== 'EnRouteToGarage' && k !== 'Preparing',
  );
}

export function getDefaultInvoiceDeliveryEmail(trip: Partial<Trip>): string {
  const { customer, passengerContact, bookingContact } = trip;

  if (customer?.type === CustomerType.Organization) {
    return bookingContact?.email;
  }

  return passengerContact?.email;
}

export function completedStatus(): boolean {
  return true;
}
